var CompanyController = function() {
    this.WRAPPER_WIDTH = 880;
    this.init();
};

CompanyController.prototype = {
    init: function() {
        var $tab = $('#js-tab');
        var $li = $tab.find('li');
        var width = parseInt(this.WRAPPER_WIDTH/$li.length);
        //console.log(width);
        $li.css({
            width: width
        });
        $li.find('a').css({
            padding: 0
        });
        var $link =  $tab.find('a');
        var $contents = $('.company');

        var hash = location.hash;
        if (hash.length > 0) {
            var $target = hash;
            $contents.stop().fadeOut();
            $($target).stop().fadeIn();
            setTimeout(function(){
                $link.removeClass('is-current');
                $link.each(function(i){
                    var _$this = $(this);
                    if (_$this.attr('href').indexOf($target) !== -1) {
                        _$this.addClass('is-current');
                    }
                });
                TweenMax.to(window, 0, {
                    scrollTo:{
                        y: 0
                    }
                });
            }, 200);
        }

        $link.on('click', function(e) {
            e.preventDefault();
            var $this = $(this);
            var $target = $this.attr('href');
            $contents.stop().fadeOut();
            $($target).stop().fadeIn();
            $link.removeClass('is-current');
            $this.addClass('is-current');
        });
    }
};

module.exports = CompanyController;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/controller/CompanyController.js
 **/